import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import SubscribersOnly from '../../../../ActionBar/_partials/SubscribersOnly';
import { useScrollToDeviationComments } from '../../../../DeviationPage/_partials/Comments/useScrollToDeviationComments';
import Stats from '../../../../Stats';
import s from './StatBlock.scss';
/** Controls rendering stats (and SubscribersOnly on mobile) for most devpages */
export var StatBlock = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var isMobile = useContext(MobileContext);
    var tier = useSubscriptionTier(deviation).tier;
    var withTierInfo = !!tier;
    var scrollToDeviationComments = useScrollToDeviationComments();
    if (isMobile && withTierInfo) {
        // the only difference between the following block and the one below
        // is designs need to have the subscribers only here on mobile
        // and the css control on how that and the stats and badges wrap
        return (React.createElement("div", { className: classnames(s['root'], className) },
            React.createElement(SubscribersOnly, { deviation: deviation }),
            React.createElement(Stats, { className: s['stats'], badgelistClassName: s['badges'], deviation: deviation, withViewCount: false, withSubscriberCount: true, onCommentClick: scrollToDeviationComments })));
    }
    return (React.createElement(Stats, { className: className, deviation: deviation, withViewCount: !withTierInfo, withSubscriberCount: withTierInfo, onCommentClick: scrollToDeviationComments }));
};
StatBlock.displayName = 'StatBlock';
export default StatBlock;
//# sourceMappingURL=StatBlock.js.map